// Third Party Imports
import PropTypes from 'prop-types';
import React from 'react';
import {ButtonOverlay} from '@homeaway/react-buttons';

// Style
import './CarouselPageNumberDesktop.less';

const CarouselPageNumberDesktop = () => (
    ({index, images}) => {
        return (
            <div className="carousel-page-number-desktop">
                <ButtonOverlay
                    className="carousel-page-number-desktop__view-fullscreen"
                    label={`Image ${index + 1} of ${images.length}.`}
                    srOnlyLabel
                    type="button"
                    size="xs"
                >
                    <div className="carousel-page-number-desktop__inner-wrapper">
                        {`${index + 1} / ${images.length}`}
                    </div>
                </ButtonOverlay>
            </div>
        );
    }
);

CarouselPageNumberDesktop.propTypes = {
    index: PropTypes.number.isRequired,
    images: PropTypes.PropTypes.instanceOf(Array).isRequired
};

export default CarouselPageNumberDesktop;



// WEBPACK FOOTER //
// ./src/universal/components/image-carousel/carouselTemplates/CarouselPageNumberDesktop/CarouselPageNumberDesktop.js